<template>
    <v-flex xs12>
        <v-card class="elevation-0 pa-5" flat>
            <h1 class="fonte text-uppercase">Relatório Quero Taxi</h1>
            <v-divider class="mt-4"></v-divider>
            <v-card class="elevation-0 mt-5" flat>
                <v-layout wrap row >
                    <v-flex xs12 sm5 class="mr-3">
                        <v-menu v-model="menuPicker" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="date1"  label="Data Inicial" color="teal" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker  locale="pt-br" v-model="date1" @input="menuPicker = false" color="teal"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm5>
                        <v-menu v-model="menuPicker2" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="date2"  format="dd/MM/yyyy" label="Data Final"  color="teal" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker locale="pt-br" v-model="date2" @input="menuPicker2 = false" color="teal"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-btn :loading="loading" color="fundo" large round @click="search" class="mt-3">
                            <v-icon left>
                                search
                            </v-icon>
                            Pesquisar
                            <template v-slot:loader>
                                <span class="custom-loader">
                                    <v-icon light>cached</v-icon>
                                </span>
                            </template>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-card>


            <v-card class="elevation-0" flat>
                <v-layout row wrap  >
                    <v-flex xs12 class="mt-3">
                        <h2 class="fonte text-uppercase mt-3">Resumo dos Pedidos</h2>
                    </v-flex>
                    <v-flex d-flex  sm4 v-for="(item,i) in headers1" :key="i">
                        <CardStatus class="mr-2"
                            v-if="formatFiltro "
                            :title="item.text"
                            :icon="item.icon || 'check'"
                            :total="formatFiltro[item.value] || 0"
                            :color="item.color"
                        ></CardStatus>
                    </v-flex>
                </v-layout>
                <v-layout row wrap space-between>
                    <v-flex xs12 class="mt-3">
                        <h2 class="fonte text-uppercase">Status dos Pedidos</h2>
                    </v-flex>
                    <v-flex d-flex sm4 v-for="(item,i) in headers" :key="i">
                        <CardStatus class="mr-2"
                            v-if="formatFiltro "
                            :title="item.text"
                            :icon="item.icon || 'check'"
                            :total="formatFiltro[item.value] || 0"
                            :color="item.color"
                        ></CardStatus>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-card>
    </v-flex>

</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import CardStatus from '../../CardStatus'
import moment from  'moment'

export default {
    components: {
        CardStatus
    },

    data() {
        return {
            menuPicker      : false,
            menuPicker2     : false,
            date1           : new Date(new Date().getTime() - (30* 24 * 60 * 60 * 1000)).toISOString().substr(0, 10),
            date2           : moment(new Date()).format('YYYY-MM-DD'),
            loading         : false,
            pedidos         : [],

            headers1         : [
                {
                    text: "Total de telefones",
                    value: "telefones",
                    color:"#00C853",
                    icon: "phone"
                },
                {
                    text: "Total de pedidos",
                    value: "pedidos",
                    color:"#FFA726",
                    icon: "list"
                }
                ],
            headers         : [

                 {
                    text: "Total de criados",
                    value: "criado",
                    color:"#00BFA5",
                    icon: "add_circle"
                },


                {
                    text: "Total de solicitados",
                    value: "solicitado",
                    color:"#1A237E",
                    icon: "message"
                },
                  {
                    text: "Sucesso",
                    value: "sucesso",
                    color:"#33691E",
                    icon: ""
                },
                {
                    text: "Total de concluidos",
                    value: "concluido",
                    color:"#26C6DA",
                    icon: "check_box"
                },
                {
                    text: "Total de expirados",
                    value: "expirado",
                    color:"#89003C",
                    icon: "remove_circle"
                },
                {
                    text: "Total de cancelados",
                    value: "cancelado",
                    color:"#FF1744",
                    icon: "clear"
                },



            ]
        }
    },

    async mounted() {
        await this.loadUserLocal()
        await this.isClientQueroTaxi(this.getUserLocal.key)
        if(this.system.empresaQueroTaxi && this.system.empresaQueroTaxi._id) {
            this.search()
        }
    },

    methods: {
        ...mapActions(['getFiltroQueroTaxi', 'isClientQueroTaxi', 'loadUserLocal']),

        formatDate(date) {
            return moment(date).format('DD-MM-YYYY')
        },

        async search() {
            this.loading = true

            const result    = await this.getFiltroQueroTaxi({
                dt_ini: this.date1,
                dt_fim: this.date2,
                empresa_id: this.system.empresaQueroTaxi._id
            })
            this.pedidos    = result.pedidos
            this.loading    = false
        }
    },

    computed: {
        ...mapState(['system']),
        ...mapGetters(['getUserLocal']),

        formatFiltro() {
            if(this.pedidos.length) {
                let empresas = [ ...new Set( this.pedidos.map( _ => _._id.empresa.id ) ) ]
                empresas = empresas.map( _ => this.pedidos.find( __ => __._id.empresa.id == _ )._id.empresa )


                let formating = empresas.map( _ => ({
                    empresa: _.dominio,
                    telefones: this.pedidos.filter( i => i._id.empresa.id == _.id ),
                    total_telefones: this.pedidos.filter( i => i._id.empresa.id == _.id ).length,
                    total_pedidos: this.pedidos.filter( i => i._id.empresa.id == _.id ).reduce( (acc, item) => acc + item.pedidos.length,0),
                    pedidos: this.pedidos.filter( i => i._id.empresa.id == _.id ).flatMap( p => p.pedidos )
                }))

                formating = formating.map( _ => ({
                    ..._,
                    status: [ ...new Set( _.pedidos ) ].map( it => ({status: it, total: _.pedidos.filter( i => i == it ).length }) )
                }))

                const makeObj = arr => {
                    let o = {}
                    for( let i of arr )o[ i.status ] = i.total
                    return o
                }

                return formating.map( f => ({
                    pedidos: f.total_pedidos,
                    telefones: f.total_telefones,
                    ...makeObj(f.status)
                }) )[0] || {}
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/user/QueroTaxi/Informes.vue